import React, { useState, useRef, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Logo1 from "../assets/images/logo.png";
import Logo from "../assets/images/logo.png";
import MenuBg from "../assets/images/mwnu-img.png";
import whiteArrow from "../assets/images/button-arrow.svg";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  Container,
  Dropdown,
  ListGroup,
  InputGroup,
  Form,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import UserIcon from "../assets/images/user-header.png";
import Search from "../assets/images/search-icon-2.svg";
import Location from "../assets/images/location-icon.svg";
import AuthMenu from "../component/AuthMenu";
import useSuburbs from "../hooks/useSuburbs";

function Header() {
  const { suburbs } = useSuburbs();

  const [activeDropdown, setActiveDropdown] = useState(null);
  const handleMouseEnter = (id) => setActiveDropdown(id);
  const handleMouseLeave = () => setActiveDropdown(null);
  const navigate = useNavigate();

  const inputGroupRef = useRef(null);
  const [inputHeight, setInputHeight] = useState(0);
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState([]);

  // Example dataset — could come from API
  const items = [
    "New York, USA",
    "Washington DC, USA",
    "Jersey City",
    "North Bergen",
    "Long Island City",
    "Greenville",
    "New York, NY",
    "Yonkers, NY",
    "Manhattan, New York, NY",
    "New York City Geographic District #2, NY",
    "New Paltz Senior High School, New Paltz, NY",
    "New Windsor School, New Windsor, NY",
    "Brooklyn, New York, NY ",
    "Bronx, New York, NY",
  ];
  useEffect(() => {
    if (inputGroupRef.current) {
      const height = inputGroupRef.current.offsetHeight;
      setInputHeight(height);
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (inputGroupRef.current) {
        setInputHeight(inputGroupRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.length > 0) {
      const results = suburbs.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase()),
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
  };

  const handleSelect = (item) => {
    setQuery(item);
    setFiltered([]);
  };

  //quick search
  const handleQuickSearch = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const input = form.querySelector('input[type="search"]');
    const value = input?.value?.trim();

    if (!value) return;
    sessionStorage.setItem("fullSuburb", value);

    const suburbName = value.split(",")[0].trim();

    const url = `/search?suburb=${encodeURIComponent(suburbName)}`;

    if (window.location.pathname === "/search") {
      window.location.href = url;
    } else {
      navigate(url);
    }
  };
  return (
    <>
      <header>
        <Navbar expand="lg" className="common-padding">
          <Container>
            <Navbar.Brand className="header-logo">
              <Link to={"/"}>
                <img width={160} src={Logo} alt="" />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Form onSubmit={handleQuickSearch}>
                <InputGroup ref={inputGroupRef}>
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    value={query}
                    onChange={handleChange}
                  />
                  <Button type="submit">
                    <img src={Search} alt="" />
                  </Button>
                </InputGroup>
                {filtered.length > 0 && (
                  <ListGroup style={{ top: inputHeight + 4 }}>
                    {filtered.map((item, index) => (
                      <ListGroup.Item
                        key={index}
                        action
                        onClick={() => handleSelect(item)}
                      >
                        <img src={Location} alt="" /> {item}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                )}
              </Form>
              <Nav className="ms-auto me-0">
                <NavDropdown
                  className={`mega-menu`}
                  title="Buy"
                  id="buy"
                  show={activeDropdown === 1}
                  onMouseEnter={() => handleMouseEnter(1)}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="mega-menu-wrap">
                    <Container>
                      <div className="mega-menu-cols">
                        <div className="mega-menu-col col-one">
                          <h3>Home for Sale</h3>
                          <Row>
                            <Col sm="6">
                              <NavDropdown.Item href="/buy?property_type=residential&listing_type=sale">
                                Home for Sale
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/buy?property_type=residential&listing_type=sale&sale_type=foreclosure">
                                Foreclosures
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/buy?property_type=residential&listing_type=sale&sale_type=fsbo">
                                For sale by owner
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                href="/buy?property_type=residential&listing_type=sale&open_house=true"
                                className="mb-0"
                              >
                                Open houses
                              </NavDropdown.Item>
                            </Col>
                            <Col sm="6">
                              <NavDropdown.Item href="/buy?property_type=residential&listing_type=sale&sale_type=new_construction">
                                New construction
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/buy?property_type=residential&listing_type=sale&sale_type=coming_soon">
                                Coming Soon
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/buy?property_type=residential&listing_type=sale&sale_type=recent_sale">
                                Recent home sales
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/buy?property_type=residential&listing_type=sale">
                                All Homes
                              </NavDropdown.Item>
                            </Col>
                          </Row>
                        </div>
                        <div className="mega-menu-col no-border">
                          <h3>Resources</h3>
                          <NavDropdown.Item href="/buy">
                            Home Buying Guide
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/buy">
                            Foreclosure center
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/buy">
                            Down payment assistance
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/buy">
                            Find a buyer's agent
                          </NavDropdown.Item>
                        </div>
                        <div className="mega-menu-col col-two menu-advertisement">
                          <img className="w-100" src={MenuBg} alt="" />
                          <div className="advertisement-details">
                            <h2>Explore Properties</h2>
                            <p>
                              Jambobay helps you find your dream home or
                              investment property across Kenya,
                              <br /> from Nairobi to Mombasa, Kisumu to Nakuru.
                            </p>
                            <a href="/" className="custom-bttn style-1 ani-1">
                              Explore Now <img src={whiteArrow} alt="" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </Container>
                  </div>
                </NavDropdown>
                <NavDropdown
                  className={`mega-menu`}
                  title="Rent"
                  id="rent"
                  show={activeDropdown === 2}
                  onMouseEnter={() => handleMouseEnter(2)}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="mega-menu-wrap">
                    <Container>
                      <div className="mega-menu-cols">
                        <div className="mega-menu-col">
                          <h3>Discover Rentals</h3>
                          <Row>
                            <Col sm="6">
                              <NavDropdown.Item href="/rent?property_type=residential&listing_type=rent&category=apartment">
                                Apartment for Rent
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/rent?property_type=residential&listing_type=rent&category=house">
                                Houses for Rent
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/rent?property_type=residential&listing_type=rent">
                                All Rental Listings
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/rent?property_type=residential&listing_type=rent&building=true">
                                All Rental Buildings
                              </NavDropdown.Item>
                            </Col>
                          </Row>
                        </div>
                        <div className="mega-menu-col no-border">
                          <h3>Resources</h3>
                          <NavDropdown.Item href="/rent">
                            Rent With real Estate
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/rent">
                            Renters Insurance
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/rent">
                            Rent Guide
                          </NavDropdown.Item>
                        </div>
                        <div className="mega-menu-col col-two menu-advertisement">
                          <img className="w-100" src={MenuBg} alt="" />
                          <div className="advertisement-details">
                            <h2>Explore Properties</h2>
                            <p>
                              Jambobay helps you find your dream home or
                              investment property across Kenya,
                              <br /> from Nairobi to Mombasa, Kisumu to Nakuru.
                            </p>
                            <a href="/" className="custom-bttn style-1 ani-1">
                              Explore Now <img src={whiteArrow} alt="" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </Container>
                  </div>
                </NavDropdown>
                <Nav.Link href="/sell">Sell</Nav.Link>
                <NavDropdown
                  className={`mega-menu`}
                  title="Commercial"
                  id="commercial"
                  show={activeDropdown === 3}
                  onMouseEnter={() => handleMouseEnter(3)}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="mega-menu-wrap">
                    <Container>
                      <div className="mega-menu-cols">
                        <div className="mega-menu-col">
                          <h3>Discover Commercials</h3>
                          <Row>
                            <Col sm="6">
                              <NavDropdown.Item href="/commercial?property_type=commercial&category=retail">
                                Retail Properties
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/commercial?property_type=commercial&category=industrial">
                                Industrial Properties
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/commercial?property_type=commercial&category=multi_family">
                                Multi-family Apartments
                              </NavDropdown.Item>
                              <NavDropdown.Item href="/commercial?property_type=commercial&category=office_building">
                                Office Buildings
                              </NavDropdown.Item>
                            </Col>
                          </Row>
                        </div>
                        <div className="mega-menu-col no-border">
                          <h3>Resources</h3>
                          <NavDropdown.Item href="/commercial">
                            Commercial Lease Agreement
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/commercial">
                            Commercial Property Management
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/commercial">
                            Lease Guide
                          </NavDropdown.Item>
                        </div>
                        <div className="mega-menu-col col-two menu-advertisement">
                          <img className="w-100" src={MenuBg} alt="" />
                          <div className="advertisement-details">
                            <h2>Explore Properties</h2>
                            <p>
                              Jambobay helps you find your dream home or
                              investment property across Kenya,
                              <br /> from Nairobi to Mombasa, Kisumu to Nakuru.
                            </p>
                            <a href="/" className="custom-bttn style-1 ani-1">
                              Explore Now <img src={whiteArrow} alt="" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </Container>
                  </div>
                </NavDropdown>

                <Nav.Link href="/mortgage-calculator">Mortgage</Nav.Link>
                <Nav.Link href="/find-an-agent">Find an Agent</Nav.Link>
                <Nav.Link href="/about-us">About Us</Nav.Link>
                <AuthMenu />
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
}
export default Header;
